import { useTranslation } from '@klv/hooks/useTranslation';
import { MFA_SUPPORT_ZENDESK_ID } from './mfa_support_zendesk_fields';

const {
  COMPANY_TEST_URL,
  ORG_MAILING_ADDRESS,
  PROFILE_NAMES,
  LAST_LOGIN_DATE,
  CAMPAIGN_FLOW_NAME,
  OTHER_EMAILS,
  RECENT_INVOICE,
} = MFA_SUPPORT_ZENDESK_ID;

export const useMfaSupportFields = () => {
  const { t } = useTranslation();

  return {
    [COMPANY_TEST_URL]: {
      formName: 'companyTestUrl',
      // zendeskId: COMPANY_TEST_URL,
      fieldType: 'text',
      label: t(
        'organisms_forms_accountAccessForm_form_mfa_support_company_test_url',
      ),
      placeholder: t(
        'organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder',
      ),
    },
    [ORG_MAILING_ADDRESS]: {
      formName: 'orgMailingAddress',
      // zendeskId: ORG_MAILING_ADDRESS,
      fieldType: 'multilineText',
      label: t(
        'organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address',
      ),
      placeholder: t(
        'organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder',
      ),
    },
    [PROFILE_NAMES]: {
      formName: 'profileNames',
      // zendeskId: PROFILE_NAMES,
      fieldType: 'multilineText',
      label: t(
        'organisms_forms_accountAccessForm_form_mfa_support_profile_names',
      ),
      placeholder: t(
        'organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder',
      ),
    },
    [LAST_LOGIN_DATE]: {
      formName: 'lastLoginDate',
      // zendeskId: LAST_LOGIN_DATE,
      fieldType: 'text',
      label: t(
        'organisms_forms_accountAccessForm_form_mfa_support_last_login_date',
      ),
      placeholder: t(
        'organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder',
      ),
    },
    [CAMPAIGN_FLOW_NAME]: {
      formName: 'campaignFlowName',
      // zendeskId: CAMPAIGN_FLOW_NAME,
      fieldType: 'text',
      label: t(
        'organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name',
      ),
      placeholder: t(
        'organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder',
      ),
    },
    [OTHER_EMAILS]: {
      formName: 'otherEmails',
      label: t(
        'organisms_forms_accountAccessForm_form_mfa_support_other_emails',
      ),
      fieldType: 'text',
      // zendeskId: OTHER_EMAILS,
      placeholder: t(
        'organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder',
      ),
    },
    [RECENT_INVOICE]: {
      formName: 'recentInvoice',
      label: t(
        'organisms_forms_accountAccessForm_form_mfa_support_recent_invoice',
      ),
      fieldType: 'text',
      // zendeskId: RECENT_INVOICE,
      placeholder: t(
        'organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder',
      ),
    },
  };
};
